import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import * as Pikaday from 'pikaday';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnInit {

  public picker : Pikaday;
  public translation : any = null;

  @Input() date: string;
  @Output() dateChange = new EventEmitter<string>();

  @ViewChild('datepicker') datepicker: ElementRef;

  constructor() { }

  ngOnInit(): void {
    import('../../shared/interfaces/datepicker').then((res) => {
      this.translation = res.default;
      Object.entries(res).forEach(
        ([key, value]) => {
          if (key === environment.defaultLanguage) {
            this.translation = value;
            this.setupPicker();
          }
        }
      );
    });
  }

  ngAfterViewInit(): void {
    this.setupPicker();
  }

  setupPicker(): void {
    if (this.translation === null) {
      return;
    }
    this.picker = new Pikaday({
      field: this.datepicker.nativeElement,
      format: 'DD/MM/YYYY',
      setDefaultDate: true,
      i18n: this.translation,
      defaultDate: moment(this.date, 'DD/MM/YYYY').toDate(),
      firstDay: 1,
      theme: 'vop-pikaday',
      onSelect: () => {
        this.dateChange.emit(this.datepicker.nativeElement.value);
      }
    });
  }

}
